import React from 'react'
import { Grid, Button } from '@material-ui/core'

import styled from 'styled-components'
import { Link } from 'gatsby'

const currentYear = new Date().getFullYear()

const StyledFooter = styled.footer`
    margin: ${(props) => (props.lowFootprint ? '0 auto' : '200px auto 100px')};
    max-width: 1100px;
    padding: 20px;
    text-align: center;
    h2 {
        font-size: 1.7rem;
        font-weight: 600;
        text-align: left;
        text-transform: uppercase;
        width: 100%;
    }
    h2,
    h3 {
        text-align: left;
        text-transform: uppercase;
    }
    a {
        color: black;
        &:visited {
            color: black;
        }
    }
    ul,
    a {
        text-align: left;
    }
    ul {
        line-height: 25px;
        list-style: none;
        display: grid;

        grid-template-columns: repeat(3, minmax(0, 1fr));
        grid-gap: 10px;
        @media (max-width: 600px) {
            grid-template-columns: 1fr;
        }
    }
`

const Footer = ({ lowFootprint, sitename = '' }) => {
    return (
        <StyledFooter lowFootprint={lowFootprint}>
            {!lowFootprint ? (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {sitename}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <ul>
                            <li>
                                <Link to="/garder-permis-alcool-volant/">
                                    Garder son permis après alcool volant
                                </Link>
                            </li>

                            <li>
                                <Link to="/consequences-alcool-volant/">
                                    Conséquences légales de l'alcool volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/accusation-garde-controle-alcool/">
                                    Accusation de garde et contrôle alcool
                                </Link>
                            </li>

                            <li>
                                <Link to="/avocat-criminel-alcool-volant/">
                                    Avocat criminel alcool volant
                                </Link>
                            </li>

                            <li>
                                <Link to="/defenses-alcool-volant/">
                                    Défenses pour alcool volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/alcool-volant-bateau/">
                                    Alcool au volant en bateau
                                </Link>
                            </li>

                            <li>
                                <Link to="/alcool-volant-motoneige-vtt/">
                                    Alcool au volant en motoneige et VTT
                                </Link>
                            </li>
                            <li>
                                <Link to="/premiere-infraction-alcool-volant/">
                                    Première infraction alcool volant
                                </Link>
                            </li>

                            <li>
                                <Link to="/alcool-volant-deuxieme-infraction/">
                                    Deuxième infraction alcool volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/obtenir-pardon-alcool-volant-quebec/">
                                    Comment obtenir un pardon pour alcool au
                                    volant!
                                </Link>
                            </li>
                            <li>
                                <Link to="/avocat-conduite-facultes-affaiblies/">
                                    Avocat conduite avec facultés affaiblies
                                </Link>
                            </li>
                            <li>
                                <Link to="/prix-avocat-alcool-volant/">
                                    Prix d'un avocat pour alcool au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/refus-souffler-alcootest/">
                                    Refuser de souffler dans l'alcootest
                                </Link>
                            </li>
                            <li>
                                <Link to="/recidive-alcool-volant/">
                                    Récidive alcool au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/recuperer-permis-apres-alcool-volant/">
                                    Récupérer son permis après l’alcool au
                                    volant!
                                </Link>
                            </li>
                            <li>
                                <Link to="/acquittement-alcool-volant-erreur-police/">
                                    Obtenir un acquittement
                                </Link>
                            </li>

                            <li>
                                <Link to="/troisieme-infraction-alcool-volant/">
                                    Troisième infraction pour alcool au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/cout-alcool-volant-quebec/">
                                    Coût d’une condamnation pour alcool au
                                    volant au Québec
                                </Link>
                            </li>
                            <li>
                                <Link to="/defense-carter-alcool-volant/">
                                    Défense Carter pour alcool au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/exemples-acquittement-alcool-volant/">
                                    Exemples d’acquittement pour alcool au
                                    volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/accusation-controle-vehicule-alcool-volant/">
                                    Accusation de garde et contrôle avec alcool
                                    au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/conduite-dangereuse-alcool-volant-sanctions/">
                                    Sanctions pour conduite dangereuse et alcool
                                    au volant
                                </Link>
                            </li>

                            <li>
                                <Link to="/alcool-volant-eviter-condamnation">
                                    Comment éviter une condamnation
                                </Link>
                            </li>
                            <li>
                                <Link to="/voyager-etats-unis-alcool-volant/">
                                    Voyager aux États-Unis avec un casier
                                    judiciaire
                                </Link>
                            </li>
                            <li>
                                <Link to="/avocat-indispensable-alcool-volant/">
                                    Avocat indispensable en cas d’alcool au
                                    volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/taux-alcoolemie-legal-quebec/">
                                    Taux d’alcoolémie légal au Québec
                                </Link>
                            </li>
                            <li>
                                <Link to="/delit-fuite-conduite-dangereuse/">
                                    Délit de fuite et conduite dangereuse
                                </Link>
                            </li>
                            <li>
                                <Link to="/alcool-volant-vehicules/">
                                    Alcool au volant et véhicules
                                </Link>
                            </li>
                            <li>
                                <Link to="/cout-accusation-conduite-facultes-affaiblies/">
                                    Coût d’une accusation pour conduite avec
                                    facultés affaiblies
                                </Link>
                            </li>
                            <li>
                                <Link to="/alcool-volant-bateau-embarcation-eau/">
                                    Alcool au volant d’un bateau ou d’une
                                    embarcation
                                </Link>
                            </li>

                            <li>
                                <Link to="/congediement-alcool-volant/">
                                    Congédiement et alcool au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/alcool-volant-limites/">
                                    Limites d’alcool au volant
                                </Link>
                            </li>
                            <li>
                                <Link to="/consequence-prime-assurance/">
                                    Conséquence sur la prime d’assurance
                                </Link>
                            </li>

                            <li>
                                <Link to="/conduite-consommation-medicaments/">
                                    Conduite après consommation de médicaments
                                </Link>
                            </li>
                            <li>
                                <Link to="/contestation-suspension-permis/">
                                    Contester une suspension de permis
                                </Link>
                            </li>
                        </ul>
                    </Grid>
                    <Grid item xs={12} sm={6}></Grid>
                </Grid>
            ) : null}
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} style={{ textAlign: 'left' }}>
                    <span>
                        Copyright © {currentYear} {sitename}.
                    </span>
                </Grid>
                <Grid item xs={12} sm={6} style={{ textAlign: 'right' }}>
                    <span>
                        <Link to="/termes-et-conditions">
                            Termes et Conditions / Politique de Confidentialité
                        </Link>
                    </span>
                </Grid>
            </Grid>
        </StyledFooter>
    )
}

export default Footer
